import './style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { PagePath } from 'constants/pagePath';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useNavigate } from 'react-router-dom';
import { FormikProps } from 'formik';
import { PurchaseSimulationInput, useITExplanationPageStore } from '../hooks';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import { DateFormatType, formatDate } from 'views/utils/converter';
import { Link } from "react-router-dom";

export type DomesticRealEstateItExplanationRequestCompleteProps = {
  symbolDetail: DomesticRealEstateSymbolDetailInfo;
  formik: FormikProps<PurchaseSimulationInput>;
  backDetailPage: () => void;
};

export const DomesticRealEstateItExplanationSymbolApplyComplete = ({
  symbolDetail,
  formik,
  backDetailPage,
}: DomesticRealEstateItExplanationRequestCompleteProps) => {
  useCustomLocationName('電子交付・IT重説のお申込み完了');
  const { param } = useITExplanationPageStore();
  const navigate = useNavigate();

  return (
    <div className="domesticRealEstateItExplanation_requestComplete">
      <div className="domesticRealEstateItExplanation_requestComplete_wrapper">
        <div className='domesticRealEstateItExplanation_requestComplete_topGroup'>
          <section className="domesticRealEstateItExplanation_requestComplete_confirmMessage">
            <div>以下の日程で、IT重説のお申込みを承りました</div>
            <div>日程が確定しましたら、お客さまのメールアドレス宛に、IT重説の日時とIT重説のためのお客さま専用URLをお送りいたします。</div>
          </section>
          <section className='domesticRealEstateItExplanation_requestComplete_reservationDateTime'>
            <div>＜予約日時＞</div>
            <div>・第1希望：{formatDate(param.meetingDate1, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime1}</div>
            <div>・第2希望：{formatDate(param.meetingDate2, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime2}</div>
            <div>・第3希望：{formatDate(param.meetingDate3, DateFormatType.Slash_yyyyMMdd)}　{param.meetingTime3}</div>
          </section>
          <section className='domesticRealEstateItExplanation_requestComplete_targetSymbol'>
            <div>＜対象案件＞</div>
            <div>{symbolDetail.ProductName}</div>
          </section>
        </div>
        <section className='domesticRealEstateItExplanation_requestComplete_info'>
          <div>※当日は、Google Meetでのご説明を予定しております。</div>
          <div>※IT重説に利用するツールについてのご相談や、日程の変更をご希望のお客さまは、
            <Button  
              label = "お問い合わせ"
              onClick= {() => navigate(PagePath.Contact)}
              buttonFill={ButtonFill.link}
            />
            よりご連絡ください。
          </div>          
        </section>
        <div className="domesticRealEstateItExplanation_requestComplete_buttons">
          <Button
            label="HOMEに戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Home)}
          />
        </div>
      </div>
    </div>
  );
};
